<template>
	<div>
		<!-- 副导航 -->
		<c-r-m-nav-cell
			ref="navcell" 
			:crm-type="crmType" 
			route-type="index"/>
			
		<div v-loading="loading" class="main-container">
			<c-r-m-list-head
				ref="listHead" 
				:crm-type="crmType" 
				:actiontype="actiontype"
				@on-handle="listHeadHandle"/>
			<filtrate-handle-view 
				class="filtrate-bar" 
				module-type="customer"
				:show-quit="true" 
				:showProductSelect="true"
				@load="loading=false" 
				@change="searchClick" />
			<!-- 统计 -->
			<div class="content">
				<div class="axis-content">
					<div id="axismain" />
				</div>
				<div class="table-content">
					<el-table 
						:data="list" 
						:header-cell-style="{'background-color':'#f6faff'}"
						stripe 
						border 
						highlight-current-row>
						<el-table-column 
							v-for="(item, index) in fieldList" 
							:key="index" 
							:prop="item.field"
							:label="item.name" 
							align="center" 
							header-align="center" 
							show-overflow-tooltip />
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import base from '../mixins/base'
	import CRMNavCell from '@/components/table/new/CRMNavCell'
	import CRMListHead from '@/components/table/new/CRMListHead'
	import {
		crmContractServiceStatistics
	} from '@/api/contract/contract'
	export default {
		mixins: [base],
		components: {
			CRMNavCell,
			CRMListHead
		},
		data() {
			return {
				crmType:"contract",
				actiontype:0,
				loading: false,
				tableHeight: document.documentElement.clientHeight - 210,
				postParams: {}, // 筛选参数
				list: [],
				axisList: [],
				fieldList: [{
						field: 'username',
						name: '员工姓名'
					},
					{
						field: 'service_sum',
						name: '服务次数'
					},
					{
						field: 'service_num',
						name: '服务企业数量'
					},
					{
						field: 'peixun_num',
						name: '培训讲座'
					},{
						field: 'zixun_sum',
						name: '咨询'
					},
					{
						field: 'lvshihan_sum',
						name: '律师函'
					},
					{
						field: 'wenshu_num',
						name: '审拟文书'
					},
					{
						field: 'jiedai_num',
						name: '接待'
					},
					{
						field: 'baifang_num',
						name: '拜访'
					},
					{
						field: 'susong_num',
						name: '诉讼'
					},
					{
						field: 'xingzheng_num',
						name: '行政事务'
					},
					{
						field: 'huifang_num',
						name: '回访'
					},
					{
						field: 'cuishou_num',
						name: '费用催收'
					},
					{
						field: 'other_num',
						name: '其他'
					}
				]
			}
		},
		methods: {
			searchClick(params) {
				this.postParams = params
				this.getRecordList()
			},

			/**
			 * 获取相关列表
			 */
			getRecordList(dataIndex) {
				this.list = []

				let params = {}

				if (typeof dataIndex !== 'undefined') {
					const dataItem = this.axisList[dataIndex]
					params.re_user_id = this.postParams.user_id
					params.structure_id = this.postParams.structure_id
					params.start_time = dataItem.start_time
					params.end_time = dataItem.end_time
				} else {
					params = this.postParams
				}

				this.loading = true
				crmContractServiceStatistics(params)
					.then(res => {
						this.loading = false
						this.list = res.data
					})
					.catch(() => {
						this.loading = false
					})
			},
			
			listHeadHandle(item){}
		},
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.main-container {
		border: 1px solid #e6e6e6;
		border-radius: 2px;
		background-color: white;
		height: 100%;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		// position: relative;
	}

	.filtrate-bar {
		background-color: white;
		padding: 15px 20px 5px 20px;
		margin-right: 15px;
	}

	.content {
		height: calc(100% - 54px);
		overflow-y: auto;
		padding: 10px 0;
	}

	.table-content {
		padding: 0 20px 0px 20px;
	}
	
	/deep/ .el-table{
		font-size: 13px;
	}
	.heise{
		color:#333 !important;
	}
	/deep/ .el-tag{
		/* color:#333 !important; */
		/* width: 85px !important; */
		overflow: hidden;
		text-align: center;
		padding:0 !important
	}
	/deep/ .el-table .el-table__cell {
	    padding: 3px 0 !important;
	}
</style>